export default "__VITE_ASSET__4TKQiRtw__"